module.exports = __webpack_public_path__ + "img/youtube.dc20374e.svg";